angular.module('lf.common')

.directive('lfSubmitOn', function () {
  return function (scope, elem, attr) {
    scope.$on(attr.lfSubmitOn, function (e) {
      setTimeout(elem.trigger.bind(elem, 'submit'), 0);
    });
  };
});
